import _forEach from 'lodash/forEach';
import templateCompiler from './template-compiler';

const lodash = { _forEach };

const html = `
<div class="<%= classes.option %> is-span">
  <label class="<%= classes.label %>"><%= title %></label>
  <div class="<%= classes.values %>">
    <% _forEach(values, function (value){ %>
      <button class="<%= value.classes.all %> is-span"
        <%= value.controls %>
        <%= value.state %>
      >
        <%= value.title %>
      </button>
    <% }) %>
  </div>
</div>`;

export default templateCompiler(html, lodash);
